import React, { useEffect, useState, useRef } from "react";
import {
  substract_icon,
  add_icon,
  check,
  close_icon,
} from "../../.././src/assets";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType } from "../../utils";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";

const LooseQuantityModal = ({
  initialQuantity,
  onConfirm,
  onCancel,
  product,
}) => {
  const [tempQuantity, setTempQuantity] = useState(initialQuantity);
  const inputRef = useRef(null);
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric");

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    // let newValue = value.replace(/[^\d.]/g, "").replace(/\.(.*)\./g, ".$1");
    let newValue = value.replace("ز", "."); // replace ز with .
    let decimalCount = (newValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
      newValue = newValue.replace(/\.(.*)\./g, ".$1"); // remove additional decimal points
    }
    if (newValue.includes(".")) {
      let decimalIndex = newValue.indexOf(".");
      let integerPart = newValue.substring(0, decimalIndex);
      let fractionalPart = newValue.substring(decimalIndex);
      fractionalPart = fractionalPart.replace(/[^\d]/g, ""); // remove non-numeric characters
      if (fractionalPart.length > 3) {
        fractionalPart = fractionalPart.substring(0, 3); // limit to 3 digits after decimal
      }
      newValue = integerPart + "." + fractionalPart;
    } else {
      newValue = newValue.replace(/[^\d]/g, ""); // allow only digits
      if (newValue.length > 4) {
        newValue = newValue.substring(0, 4); // limit to 4 digits without decimal
      }
    }
    e.target.value = newValue;

    setTempQuantity(newValue);
    if (newValue === "") {
      setTempQuantity(0);
    } else {
      const floatValue = parseFloat(newValue);
      if (floatValue < 10000) {
        setTempQuantity(floatValue);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      console.log("MMMM");
      onConfirm(tempQuantity);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onCancel();
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-30 backdrop-blur-md drop-shadow-sm">
      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <section
  className={` flex flex-col px-12 py-12 text-lg font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 max-md:px-5 z-50 ${
    deviceType === "tablet" ? "fixed left-20" : "relative"
  }`}
  style={{ width: "500px" }}
>

        <header className="flex gap-5 text-2xl max-md:flex-wrap max-md:max-w-full">
          <h1 className="flex-auto my-auto">{t("Enter Quantity")}</h1>
          <button
            type="button"
            onClick={onCancel}
            className="absolute top-4 right-3 text-zinc-800 bg-transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </header>
        <div
          className={`flex flex-row items-center ${
            i18n.language === "ar" ? "justify-end" : "justify-start"
          }`}
        >
          <div className="relative w-full">
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              maxLength={7}
              // value={tempQuantity}
              readOnly={deviceType === "tablet"} // ✅ disables system keyboard
              placeholder={tempQuantity}
              onFocus={() => {
                if (deviceType === "tablet") {
                  setKeyboardMode?.("numeric"); // ✅ safely call setter
                  setShowKeyboard?.(true);
                }
              }}
              onChange={handleInput}
              onKeyPress={handleKeyPress}
              onKeyDown={handleKeyDown}
              className="p-3 mt-4 rounded-xl border border-1 border-neutral-400 border-opacity-50 text-black w-full focus:outline-none"
            />

            <span
              className={`absolute ${
                i18n.language === "ar" ? "left-3" : "right-3"
              } top-10 transform -translate-y-1/2 text-md text-black`}
            >
              {(product.uom == 'KG' && product.is_selling_gram) ?  t('gm') : t(product.uom)}
              {/* {t("KG")} */}
            </span>
           
          </div>

         
        </div>
        <div className="flex justify-between gap-5">
          <button
            onClick={onCancel}
            className="justify-center items-center px-12 py-3.5 mt-10 text-xl text-center text-[#7EC242] rounded-lg border-2 border-[#7EC242] border-solid capitalize whitespace-nowrap bg-white rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full"
          >
            {t("Cancel")}
          </button>
          <button
            onClick={() => onConfirm(tempQuantity)}
            className="justify-center items-center px-12 py-3.5 mt-10 text-xl text-center text-white capitalize whitespace-nowrap bg-[#7EC242] rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full"
          >
            {t("Confirm")}
          </button>
        </div>
      </section>
      {deviceType === "tablet" && showKeyboard && (
        <AlphaNumericKeyboardModal
          mode={keyboardMode}
             width="42%"
            maxWidth="42%"
          maxHeight="54%"
          onClose={() => setShowKeyboard(false)}
          onKeyPress={(key) => {
            if (key === "DEL") {
             setTempQuantity((prev) => (typeof prev === "string" ? prev.slice(0, -1) : ""));

            } else if (key === "SPACE") {
              setTempQuantity((prev) => prev + " ");
            } else {
              const newVal = tempQuantity + key;
              if (newVal.match(/^\d*\.?\d{0,2}$/) && newVal < 10000000) {
                setTempQuantity(newVal);
              }
            }
          }}
        />
      )}
    </div>
  );
};

export default LooseQuantityModal;
